import { render } from "./RegisterPage.vue?vue&type=template&id=6699699e&scoped=true&ts=true"
import script from "./RegisterPage.vue?vue&type=script&lang=ts"
export * from "./RegisterPage.vue?vue&type=script&lang=ts"

import "./RegisterPage.vue?vue&type=style&index=0&id=6699699e&scoped=true&lang=scss"

import exportComponent from "/Volumes/DATA/Project/WebsiteProject/QLTS/QLTS_FE/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6699699e"]])

export default __exports__